import React, { useEffect, useState } from "react";
import z from "zod"
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Accordion, Button, Col, Container, Form, FormCheck, Row } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../../../components/Loader/Loading"
import ConfiguracoesSistemaPrincipal from "../../ConfiguracoesSistemaPrincipal";
import { PermissoesService } from "../../../../services/api/Usuarios/PermissoesService";
import ListGruposSecoesForm from "../ListGruposSecoesForm";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const GruposUsuariosCadEdit = () => {

    const schemaAcoes = z.object({
        nome: z.coerce.string(),
        value: z.coerce.string(),
        acaoId: z.coerce.string(),

    })
    const schemaSecoes = z.object({
        nome: z.coerce.string(),
        descricao: z.coerce.string(),
        secaoId: z.coerce.string(),
        acoesIds: z.array(schemaAcoes),


    })

    const schemaPermissoes = z.object({
        //areasId: z.coerce.string(),
        areasNome: z.coerce.string(),
        secoes: z.array(schemaSecoes)

    })
    const schema = z.object({
        nome: z.string().min(3, "O nome deve ter no mínimo 3 letras"),
        permissoes: z.array(schemaPermissoes)
    })
    const navigate = useNavigate();
    const [grupo, setGrupo] = useState(null)
    const { idGrupo } = useParams()
    const { register, handleSubmit, setValue, getValues, watch, control, formState: { errors } } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(schema),
        values: grupo
    })
    const watchAlteraSenha = watch('alteraSenha')
    const [disableSalvar, setDisableSalvar] = useState(false)
    const [isLoading, setIsloading] = useState(true)


    const { fields: permissoesFields, } = useFieldArray({ control, name: 'permissoes' })



    const areasSecoesAdapter = (dados) => {

        let dadosAreas = []

        dados.map((itemArea) => {
            let secoes = [];
            itemArea?.secoes.map((itemSecoes) => {
                let acoes = [];



                itemSecoes.acoesIds.map((itemAcoes) => {
                    acoes.push({
                        acaoId: itemAcoes.id,
                        nome: itemAcoes.nome,
                    })
                })
                secoes.push({
                    secaoId: itemSecoes.id,
                    nome: itemSecoes.nome,
                    descricao: itemSecoes.descricao,
                    acoesIds: acoes
                })



            })
            // console.log(secoes)
            dadosAreas.push({
                areasId: itemArea.id.toString(),
                areasNome: itemArea.nome,
                secoes: secoes
            })



        })

        //console.log(dados)
     //   console.log(dadosAreas)
        setValue('permissoes', dadosAreas)
        return dadosAreas;
    }



    const fetchSecoes = async () => {
        const data = await PermissoesService.getAllSecoes({ separadoPorArea: true })
        if (data.success) {
            let result = areasSecoesAdapter(data.data)
            return result
        }
    }


    const fetchGrupo = async () => {
        setIsloading(true);
        const data = await PermissoesService.getGrupoById(idGrupo)
        if (data.success) {

            let userData = data.data

          //  console.log(userData)



            let listPermissoes = []
            if (userData?.permissoes != null) {
                listPermissoes = await fetchSecoes()


                userData.permissoes.map((item) => {

                    let permGrupoIndex = listPermissoes.findIndex(perm => perm.areasId == item.secoes.permissoesAreasId)
                    let secaoIndex = listPermissoes[permGrupoIndex].secoes.findIndex(sec => sec.secaoId == item.secoes.id)
                    let acaoIndex = listPermissoes[permGrupoIndex].secoes[secaoIndex].acoesIds.findIndex(acao => acao.acaoId == item.acoes.id)

                    //    console.log(item)
                    //    console.log(permGrupoIndex)
                    //     console.log(listPermissoes[permGrupoIndex].secoes[secaoIndex].acoesIds.findIndex(acao => acao.acaoId == item.acoes.id))

                    let acao = listPermissoes[permGrupoIndex].secoes[secaoIndex].acoesIds[acaoIndex]
               
                    listPermissoes[permGrupoIndex].secoes[secaoIndex].acoesIds[acaoIndex] = {
                        ...listPermissoes[permGrupoIndex].secoes[secaoIndex].acoesIds[acaoIndex],
                        value: (item.status == 1) ? true : false
                    }
                   

                })
                setValue('permissoes', listPermissoes)


            }
            setGrupo({
                ...userData,
                nome: userData.nome,
                permissoes: listPermissoes
            })


        }

        setIsloading(false);
    }
    useEffect(() => {


        if (idGrupo != null) {
            fetchGrupo(idGrupo);
        } else {
            setIsloading(false);
            fetchSecoes()

            setGrupo({
                ...grupo,
                alteraSenha: "1"
            })
        }

    }, [])


    const onSubmit = async (dados) => {
      //  console.log(dados)

       setDisableSalvar(true)
               let permissoesForm = []
        dados.permissoes.map((itemAreas) => {

        //    console.log(itemAreas)
            itemAreas.secoes.map((itemSecoes) => {

                itemSecoes.acoesIds.map((itemAcoes) => {
                    permissoesForm.push({
                        secoesId: itemSecoes.secaoId,
                        acoesId: itemAcoes.acaoId,
                        status: (itemAcoes.value == 'true') ? 1 : 0
                    })
                })
                //  console.log(itemSecoes)
            })

        })



        let dataForm = {
            nome: dados.nome,
            permissoes: permissoesForm
        }



        if (idGrupo == null) {
            const user = await PermissoesService.storeGruposPermissoes(dataForm);
            if (user.success) {
                navigate('/admin/configuracoes/gruposUsuarios/')
            } else {
                alert(user.msg)
                setDisableSalvar(false)
            }

        } else {


            const user = await PermissoesService.updateGruposPermissoes(idGrupo, dataForm);

           // console.log(user)
            if (user.success) {
                navigate('/admin/configuracoes/gruposUsuarios/')
            } else {
                setDisableSalvar(false)
            }

        }
    }
    // console.log(permissoesFields)
    //  console.log(grupo)
    //console.log(errors)

    return (
        <>
            <ConfiguracoesSistemaPrincipal>
                <Container fluid>
                    <h4 className="text-primary">Grupos de Usuário - {(idGrupo != null) ? 'Editar' : 'Cadastrar'}</h4>
                    <hr></hr>

                    {(isLoading) ? <Loading /> : (
                        <>
                            <Form>

                                <Row className="mb-10">
                                    <Form.Group as={Col} sm={4}>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control type="text" placeholder="Nome"
                                            {...register('nome')}
                                            isInvalid={!!(errors?.name)}
                                        ></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors?.name?.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                </Row>
                        <br></br>
                        <h5 className="">Permissões</h5>
                                <Accordion defaultActiveKey="0" flush>


                                    {permissoesFields?.map((item, indexPerm) => (

                                        <Accordion.Item eventKey={indexPerm} key={indexPerm}>
                                            <Accordion.Header>{item.areasNome}</Accordion.Header>
                                            <Accordion.Body>
                                                <ListGruposSecoesForm indexPerm={indexPerm} {...{ control, register, getValues, setValue, errors }} />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))}


                                </Accordion>
                                <div className="text-center">
                                    <Button variant="danger" size="sm" className="mr-10" href={'/admin/configuracoes/gruposUsuarios'}>Cancelar</Button>
                                    <Button variant="primary" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                        {(disableSalvar) ? <>
                                         <FontAwesomeIcon icon={faSpinner} spin /> Salvando...
                                        </> : 'Salvar'}</Button>

                                </div>
                            </Form>
                        </>)}


                </Container >


            </ConfiguracoesSistemaPrincipal >


        </>
    )


}

export default GruposUsuariosCadEdit;